var messages = {
  emptyText: 'コンテンツなし',
  clickToDrag: 'クリックしてドラッグ',
  validationTableName: 'データ行',
  validationError: '$count個の $table_name の保存に失敗しました。',
  isRequired: '記入必須項目',
  selectAll: '全てを選択'
};
export default messages;